// extracted by mini-css-extract-plugin
module.exports = {"VideoModal":"VideoModal_VideoModal__19L5Q","CloseIcon":"VideoModal_CloseIcon__32_QS","Video":"VideoModal_Video__23_1M"};